import { render, staticRenderFns } from "./bindPrm.vue?vue&type=template&id=08a71aac&scoped=true"
import script from "./bindPrm.vue?vue&type=script&lang=js"
export * from "./bindPrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a71aac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a71aac')) {
      api.createRecord('08a71aac', component.options)
    } else {
      api.reload('08a71aac', component.options)
    }
    module.hot.accept("./bindPrm.vue?vue&type=template&id=08a71aac&scoped=true", function () {
      api.rerender('08a71aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/userSetting/account/bindPrm.vue"
export default component.exports